import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styles from './PostBody.css';
var marked = require('marked');

marked.setOptions({
  renderer: new marked.Renderer(),
  gfm: true,
  tables: true,
  breaks: false,
  pedantic: false,
  sanitize: false,
  smartLists: true,
  smartypants: false
});

class PostBody extends Component {
  static propTypes = {
    body: PropTypes.string.isRequired,
  };

  render() {
    const { body } = this.props;
    let resizedBody = body.replace(/.jpg\)/g, '.jpg?w=972&fm=jpg&fl=progressive)').replace(/.png\)/g, '.png?w=972)');

    return (
      <div className={styles.blogPost} dangerouslySetInnerHTML={{ __html: marked(resizedBody) }}></div>
    );
  }
}

export default PostBody;



// WEBPACK FOOTER //
// ./src/components/post-body/PostBody.js